import { render, staticRenderFns } from "./ClinicHealthEducationVideosWrapper.vue?vue&type=template&id=d134edc0&scoped=true"
import script from "./ClinicHealthEducationVideosWrapper.vue?vue&type=script&lang=js"
export * from "./ClinicHealthEducationVideosWrapper.vue?vue&type=script&lang=js"
import style0 from "./ClinicHealthEducationVideosWrapper.vue?vue&type=style&index=0&id=d134edc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d134edc0",
  null
  
)

export default component.exports